<template>
    <td-dialog
        :title="$t(title)"
        append-to-body="true"
        :before-close="roleDialogClose"
        :visible.sync="dialogRoleVisible"
        width="600px"
        height="460px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-container>
            <el-header>
                <el-form :inline="true" :model="fromRole" ref="fromRole" :rules="rules" label-position="right" label-width="120px">
                    <el-row :gutter="20">
                        <el-col>
                            <el-form-item :label="$t('pgCommon.CUSTOM_ICONS')">
                                <td-input v-model="fromRole.roleIds"></td-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
        </el-container>
        <span slot="footer" style="text-align:left">
            <td-button type="primary" @click="save">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="roleDialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
export default {
    props: ['title', 'dialogRoleVisible', 'templateKey', 'roleParam'],
    created() {
        if (this.$common.systemInfo.systemId) {
            this.fromRole.sSysFlg = this.$common.systemInfo.systemId;
        } else {
            this.fromRole.sSysFlg = 'PG';
        }
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery();
    },
    // 定义数据
    data() {
        return {
            
        };
    },
    // 方法的实现
    methods: {
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sysFlg: this.fromRole.sSysFlg,
                roleName: this.fromRole.roleName,
                deptType: this.fromRole.deptType,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            Api.listRoleInfos(JSON.stringify(param), response => {
                if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
                this.feedBack();
            });
        },
        save: function() {
            this.loading = true;
            let roleIdStr = '';
            let roleNameStr = '';
            for (let obj in this.fromRole.roleIds) {
                if ('86884ef8664e41e18effd8bb53d95482' != this.fromRole.roleIds[obj].id) {
                    if (roleIdStr === '') {
                        roleIdStr += this.fromRole.roleIds[obj].id;
                        if (undefined != this.fromRole.roleIds[obj].orgName && 'undefined' != this.fromRole.roleIds[obj].orgName) {
                            roleNameStr += this.fromRole.roleIds[obj].orgName;
                        } else {
                            roleNameStr += this.$t('pgCommon.NOT_HAVE');
                        }
                    } else {
                        roleIdStr += ',' + this.fromRole.roleIds[obj].id;
                        if (undefined != this.fromRole.roleIds[obj].orgName && 'undefined' != this.fromRole.roleIds[obj].orgName) {
                            roleNameStr += ',' + this.fromRole.roleIds[obj].orgName;
                        } else {
                            roleNameStr += ',' + this.$t('pgCommon.NOT_HAVE');
                        }
                    }
                }
            }
            if (!this.fromRole.roleIds.length || this.fromRole.roleIds.length == 0) {
                roleIdStr = "null";
            }
            let param = {
                processDefKey: this.templateKey,
                taskDefKey: this.roleParam.taskKey,
                roleIds: roleIdStr,
                roleNames: roleNameStr,
                flag: this.roleParam.tasksFlag,
                proDefId: this.templateKey + ':TEMP'
            };
            Api.saveNodeUser(JSON.stringify(param), response => {
                if (this.$t(this.$common.requestCode.SUCCESS_INFO_CODE) != response.data.statusCode) {
                    this.loading = false;
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                this.roleDialogClose();
            });
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        //关闭角色dialog
        roleDialogClose: function() {
            this.$emit('roleDialogClose');
            this.dialogRoleVisible = false;
        }
    }
};
</script>
